"use strict";

exports.__esModule = true;
exports.routeThroughBrowserOrApp = exports.hashShouldBeFollowed = exports.pathIsNotHandledByApp = exports.urlsAreOnSameOrigin = exports.authorIsForcingNavigation = exports.anchorsTargetIsEquivalentToSelf = exports.findClosestAnchor = exports.navigationWasHandledElsewhere = exports.slashedPathname = exports.userIsForcingNavigation = undefined;

exports.default = function (root, cb) {
  var clickHandler = routeThroughBrowserOrApp(cb);

  root.addEventListener("click", clickHandler);

  return function () {
    return root.removeEventListener("click", clickHandler);
  };
};

var _escapeStringRegexp = require("escape-string-regexp");

var _escapeStringRegexp2 = _interopRequireDefault(_escapeStringRegexp);

var _gatsbyLink = require("gatsby-link");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userIsForcingNavigation = exports.userIsForcingNavigation = function userIsForcingNavigation(event) {
  return event.button !== 0 || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
};

// IE does not include leading slash in anchor.pathname
var slashedPathname = exports.slashedPathname = function slashedPathname(pathname) {
  return pathname[0] === "/" ? pathname : "/" + pathname;
};

var navigationWasHandledElsewhere = exports.navigationWasHandledElsewhere = function navigationWasHandledElsewhere(event) {
  return event.defaultPrevented;
};

var findClosestAnchor = exports.findClosestAnchor = function findClosestAnchor(node) {
  for (; node.parentNode; node = node.parentNode) {
    if (node.nodeName.toLowerCase() === "a") {
      return node;
    }
  }

  return null;
};

var anchorsTargetIsEquivalentToSelf = exports.anchorsTargetIsEquivalentToSelf = function anchorsTargetIsEquivalentToSelf(anchor) {
  return (
    /* If target attribute is not present it's treated as _self */
    anchor.hasAttribute("target") === false ||

    /**
     * The browser defaults to _self, but, not all browsers set 
     * a.target to the string value `_self` by default
     */

    /** 
     * Assumption: some browsers use null/undefined for default 
     * attribute values 
     */
    anchor.target == null ||

    /** 
     * Some browsers use the empty string to mean _self, check 
     * for actual `_self` 
     */
    ["_self", ""].indexOf(anchor.target) !== -1 ||

    /**
     * As per https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target
     */
    anchor.target === "_parent" && (!anchor.ownerDocument.defaultView.parent || // Assumption: This can be falsey
    anchor.ownerDocument.defaultView.parent === anchor.ownerDocument.defaultView) || anchor.target === "_top" && (!anchor.ownerDocument.defaultView.top || // Assumption: This can be falsey
    anchor.ownerDocument.defaultView.top === anchor.ownerDocument.defaultView)
  );
};

var authorIsForcingNavigation = exports.authorIsForcingNavigation = function authorIsForcingNavigation(anchor) {
  return (
    /**
     * HTML5 attribute that informs the browser to handle the 
     * href as a downloadable file; let the browser handle it
     */
    anchor.hasAttribute("download") === true ||

    /**
     * Let the browser handle anything that doesn't look like a 
     * target="_self" anchor
     */
    anchorsTargetIsEquivalentToSelf(anchor) === false
  );
};

// https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
var urlsAreOnSameOrigin = exports.urlsAreOnSameOrigin = function urlsAreOnSameOrigin(origin, destination) {
  return origin.protocol === destination.protocol &&

  /* a.host includes both hostname and port in the expected format host:port */
  origin.host === destination.host;
};

var pathIsNotHandledByApp = exports.pathIsNotHandledByApp = function pathIsNotHandledByApp(destination) {
  var pathStartRegEx = new RegExp("^" + (0, _escapeStringRegexp2.default)((0, _gatsbyLink.withPrefix)("/")));
  var pathFileExtensionRegEx = /^.*\.((?!htm)[a-z0-9]{1,5})$/i;

  return (
    /** 
     * For when pathPrefix is used in an app and there happens to be a link
     * pointing to the same domain but outside of the app's pathPrefix. For
     * example, a Gatsby app lives at https://example.com/myapp/, with the
     * pathPrefix set to `/myapp`. When adding an absolute link to the same
     * domain but outside of the /myapp path, for example, <a
     * href="https://example.com/not-my-app"> the plugin won't catch it and
     * will navigate to an external link instead of doing a pushState resulting
     * in `https://example.com/myapp/https://example.com/not-my-app`
     */
    pathStartRegEx.test(slashedPathname(destination.pathname)) === false ||

    /**
     * Don't catch links pointed at what look like file extensions (other than
     * .htm/html extensions).
     */
    destination.pathname.search(pathFileExtensionRegEx) !== -1
  );
};

var hashShouldBeFollowed = exports.hashShouldBeFollowed = function hashShouldBeFollowed(origin, destination) {
  return destination.hash !== "" && (
  /**
   * Dynamically created anchor links (href="#my-anchor") do not always 
   * have pathname on IE 
   */
  destination.pathname === "" ||

  /* Don't catch links pointed to the same page but with a hash. */
  destination.pathname === origin.pathname);
};

var routeThroughBrowserOrApp = exports.routeThroughBrowserOrApp = function routeThroughBrowserOrApp(hrefHandler) {
  return function (event) {
    if (userIsForcingNavigation(event)) return true;

    if (navigationWasHandledElsewhere(event)) return true;

    var clickedAnchor = findClosestAnchor(event.target);
    if (clickedAnchor == null) return true;

    if (authorIsForcingNavigation(clickedAnchor)) return true;

    // IE clears the host value if the anchor href changed after creation, e.g.
    // in React. Creating a new anchor element to ensure host value is present
    var destination = document.createElement("a");
    destination.href = clickedAnchor.href;

    // In IE, the default port is included in the anchor host but excluded from
    // the location host.  This affects the ability to directly compare
    // location host to anchor host.  For example: http://example.com would
    // have a location.host of 'example.com' and an destination.host of
    // 'example.com:80' Creating anchor from the location.href to normalize the
    // host value.
    var origin = document.createElement("a");
    origin.href = window.location.href;

    if (urlsAreOnSameOrigin(origin, destination) === false) return true;

    if (pathIsNotHandledByApp(destination)) return true;

    if (hashShouldBeFollowed(origin, destination)) return true;

    event.preventDefault();

    hrefHandler("" + slashedPathname(destination.pathname) + destination.search + destination.hash);

    return false;
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-catch-links/catch-links.js
// module id = 781
// module chunks = 231608221292675